import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueSmoothScroll from 'vue3-smooth-scroll'

const app = createApp(App);
app.use(router);
app.use(store);
app.use(VueLazyload);
app.use(VueSmoothScroll);
app.mount('#app')
